"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const EconomicTable_vue_1 = __importDefault(require("../components/EconomicTable.vue"));
const EconomicStep_1 = __importDefault(require("../modules/models/EconomicStep"));
const StepHeader_vue_1 = __importDefault(require("../components/StepHeader.vue"));
const StepFooter_vue_1 = __importDefault(require("../components/StepFooter.vue"));
let EconomicSummaryStep = class EconomicSummaryStep extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = new EconomicStep_1.default({ id: 'economic_summary_step', data: { fields: [], selectedFields: [] } });
        this.loaderSearch = false;
        this.textFilter = null;
        this.fieldsFilters = [];
    }
    /* async mounted() {
        await this.STEP_CONTROLLER.getFields();
    } */
    beforeStep() {
        window.location.href = '/map_setup_activation';
    }
    /*  async sendFields() {
         await this.STEP_CONTROLLER.sendFields();
         window.location.href = '/dashboard';
     } */
    get totalPrice() {
        return `${this.STEP_CONTROLLER.totalPrice}`;
    }
    onSearchChange(f) {
        this.loaderSearch = true;
        this.textFilter = f;
        if (f.length > 0) {
            this.fieldsFilters = this.STEP_CONTROLLER.data.fields
                .filter((field) => field.fieldName
                .toUpperCase()
                .includes(f.toUpperCase()) ||
                field.farmName
                    .toUpperCase()
                    .includes(f.toUpperCase()))
                .map((sam) => sam);
        }
        else {
            this.textFilter = null;
            this.fieldsFilters = this.STEP_CONTROLLER.data.fields;
        }
        setTimeout(() => {
            this.loaderSearch = false;
        }, 500);
    }
};
EconomicSummaryStep = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, EconomicTable: EconomicTable_vue_1.default, StepFooter: StepFooter_vue_1.default, StepHeader: StepHeader_vue_1.default, Search: bmk_ui_framework_1.Search }
    })
], EconomicSummaryStep);
exports.default = EconomicSummaryStep;
